import type { TooltipStrings } from '@/constants/localization'

import { depositTooltips } from '@/constants/tooltips/deposit'
import { generalTooltips } from '@/constants/tooltips/general'
import { portfolioTooltips } from '@/constants/tooltips/portfolio'
import { tradeTooltips } from '@/constants/tooltips/trade'
import { withdrawTooltips } from '@/constants/tooltips/withdraw'

export const tooltipStrings: TooltipStrings = {
  ...depositTooltips,
  ...generalTooltips,
  ...portfolioTooltips,
  ...tradeTooltips,
  ...withdrawTooltips,
} as const
